import { render, staticRenderFns } from "./ui-layout.vue?vue&type=template&id=44df14b0&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44df14b0')) {
      api.createRecord('44df14b0', component.options)
    } else {
      api.reload('44df14b0', component.options)
    }
    module.hot.accept("./ui-layout.vue?vue&type=template&id=44df14b0&lang=pug&", function () {
      api.rerender('44df14b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-layout.vue"
export default component.exports